<template>
  <div class>
    <div slot="header" class="clearfix" style="background-color: #f2f2f2; padding: 20px">
      <span style="font-weight: 600; color: #000; line-height: 10px">协议信息</span>
      <!-- <download-excel :data="json_data" :fields="json_fields" :name="exName" class="exportClass">导出</download-excel> -->
      <button type="success" plain @click="exportResult" class="exportClass">导出</button>
      <el-button type="success" plain @click="cancel" style="float: right;margin-top: -5px;">返回</el-button>
    </div>
    <div class style="margin-top: 30px;">
      <el-form :model="form"  ref="form" label-width="150px">
        <el-form-item label="协议名称" prop="name">
          <div style="margin-left: 50px">{{ form.name || "--"  }}</div>
        </el-form-item>
        <el-form-item label="协议内容" prop="agreeContent">
          <el-row style="margin-left: 50px">
            <el-col :span="8">
              <span>协议中文</span>
            </el-col>
            <el-col :span="8">
              <span>协议英文</span>
            </el-col>
            <el-col :span="8">
              <span>数据类型</span>
            </el-col>
          </el-row>
          <el-row v-for="(_item, index) in form.content" :key="index" style="margin-left: 50px;">
            <el-col :span="8">
              <div>{{ _item.protocolCHS || "--" }}</div>
            </el-col>
            <el-col :span="8">
              <div>{{ _item.protocolENG || "--"  }}</div>
            </el-col>
            <el-col :span="5">
              <div>{{ _item.dataType || "--"  }}</div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import FileSaver from 'file-saver'
export default {
  name: "tongzhiguanli",
  components: {},
  data() {
    return {
      form: {
        name: "",
        content: [],
      },
      exName:'',//表名称
      json_data:[], // 表内容
      json_fields:{  //表头
        '序号':'type',
        '协议中文':'protocolCHS',
        '协议英文':'protocolENG',
        '数据类型':'dataType'
      },
    };
  },
  computed: {},
  methods: {
    cancel() {
      this.$router.go(-1);
    },
    exportResult(){
      console.log(1111)
      // 将json转换成字符串
      const data = JSON.stringify(this.form.content)
      console.log(data,'2222')
      const blob = new Blob([data], {type: 'application/json'})
      FileSaver.saveAs(blob, '协议内容.json')
    },
  },
  mounted() {
    let detail = this.$route.query.data;
    this.form = {
      name: detail.name,
      content: JSON.parse(detail.content)
    };
    this.exName = this.form.name + '协议内容表'
    this.json_data = this.form.content
    for(let i in this.json_data){
      this.json_data[i].type=parseInt(i)+1
    }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {

  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.btn {
  width: 600px;
  height: 50px;
  margin-top: 10px;
  margin-left: 40%;
}
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color:#00cc00;
}

.exportClass{
  float:right;
  background: #f0f9eb;
  width: 50px;height: 30px;
  text-align: center;line-height: 30px;
  margin-top: -5px;margin-left: 10px;
  border: 1px solid #c2e7b0;color: #93c26d;
  border-radius: 3px;
  cursor: pointer;
}
.exportClass:hover{
  background: #67c23a;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/agreementManagement/agreementDetail.vue